<template>
    <div class="d-flex">

        <div class="user_profile d-none d-sm-block">
            <span class="user_link">
                <strong>{{userName}}</strong><i class="fas fa-caret-down"></i>
                <span v-if="badge" class="menu-badge ml-2">{{badge}}</span>
            </span>
            <div id="user-menu" class="pop-up">
                <template v-if="dealer && dealer.x3_id">
                    <a href="#" @click.prevent="copyX3Code">
                        <!-- dealer x3 code -->
                        <div class="user-profile-code d-flex flex-row justify-content-start">
                            <div class="user-profile-detail">
                                <div class="user-profile-code-copy">
                                    <icon-copy />
                                </div>
                                <span class="user-profile-detail-title">{{$t('Dealer code')}}:</span><br />
                                <span class="user-profile-detail-title"><b>{{dealer.x3_id}}</b></span>
                            </div>
                        </div>
                    </a>
                    <hr />
                </template>

                <template  v-if="!hideAccountMenu">
                    <template v-for="(item, index) in navSideItems">
                        <router-link v-if="checkMenuLicense(item)" :to="{name: item.url}" exact-path :disabled="checkMenuLicense(item)" v-bind:key="index">
                            <div class="user-profile-link d-flex flex-row justify-content-start">
                                <div class="user-profile-detail">
                                    <span class="user-profile-detail-title">{{$t(item.name)}}</span>
                                    <span
                                        v-if="item.notification && menuBadge(item.notification)" class="menu-badge side-fixed">
                                    {{menuBadge(item.notification)}}
                                </span><br>
                                </div>
                            </div>
                        </router-link>
                        <a v-else role="link" class="cursor-pointer" aria-disabled="true" v-on:click="showMenuLicensePopup(item)" v-bind:key="index">
                            <div class="user-profile-link d-flex flex-row justify-content-start">
                                <div class="user-profile-detail">
                                    <span>{{$t(item.name)}}</span>
                                </div>
                            </div>
                        </a>
                    </template>
                </template>

                <a href="#" v-on:click="logout">
                    <!-- Logout -->
                    <div class="user-profile-link d-flex flex-row justify-content-start">
                        <div class="user-profile-detail">
                            <span class="user-profile-detail-title">{{$t("Logout")}}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <nine-dots></nine-dots>
    </div>


</template>
<script>

import {copyToClipboard} from "../js/services/copyToClipboard";
import IconCopy from "./IconCopy";
import licenseHelpers from "../customer_area/js/licenseHelpers";
import NineDots from "./NineDots.vue";

export default {
        name: 'head-side-menu',
        mixins: [licenseHelpers],
        props: ['hideAccountMenu'],
        components: {
            NineDots,
            IconCopy,
        },
        data: () => ({
            navSideItems: [],
            customer: {},
            dealer: {
                x3_id: null,
            },
            notifications: {},
        }),
        computed: {
            userName() {
                let user = this.$store.getters.getUser;
                if(user.name)
                    return user.name + ' ' + user.surname;
                return user.email
            },
            badge() {
                return (this.$store.getters.getNotifications.total) ? this.$store.getters.getNotifications.total : 0;
            },
            menuBadge() {
                return (item) => {
                    let notifications = 0
                    
                    if(this.$store.getters.getNotifications.types) {
                        if(Array.isArray(item)) {
                            item.forEach(key => {
                                notifications += this.$store.getters.getNotifications.types[key] ? this.$store.getters.getNotifications.types[key] : 0
                            })
                        } else {
                            notifications = this.$store.getters.getNotifications.types[item] ? this.$store.getters.getNotifications.types[item] : 0
                        }
                    }

                    return notifications
                }
            }
        },
        mounted() {
            this.navSideItems = this.$store.getters.getSideMenu;
            this.customer = this.$store.getters.getCustomer;
            this.dealer = this.$store.getters.getDealer;
        },
        methods: {

            logout: function () {
                this.$store.dispatch('account/logout')
                    .then(() => {});
            },

            copyX3Code: function() {
                if(this.dealer && this.dealer.x3_id) {
                    if(copyToClipboard(this.dealer.x3_id)) {
                        this.copyNotify('info')
                    } else {
                        this.copyNotify('error')
                    }
                }
            },

            copyNotify: function(type) {
                this.$notify({
                    type: type,
                    text: (type == 'info') ? this.$t('Dealer code copied to clipboard.') : this.$t('An error occurred while copying the code. Try again.'),
                })
            },

        },

    }
</script>

<style lang="css">
.sync-toggle {
    font-size: small;
}
</style>
